import { formatSeconds } from '~/utils/time';

interface GameTimerProps {
  moves: number;
  seconds: number;
}

export function GameTimer({ moves, seconds }: GameTimerProps) {
  return (
    <div className='mt-6 flex items-center justify-center rounded-lg border px-4 py-1 text-center text-sm text-blue'>
      <dl className='w-20'>
        <dt className='font-greycliff-bold inline'>Moves:</dt>{' '}
        <dd className='inline'>{moves}</dd>
      </dl>
      <div aria-hidden='true' className='mx-2 h-3 border-l border-blue/50' />
      <dl className='w-20'>
        <dt className='font-greycliff-bold inline'>Time:</dt>{' '}
        <dd className='inline'>{formatSeconds(seconds)}</dd>
      </dl>
    </div>
  );
}
